<script lang="ts" setup>
import { onMounted, defineAsyncComponent } from 'vue'
import { CATEGORY_GAME_SLUG } from '~/resources/lobby-games/urls'
import GameItem from '~/components/common/lobby-games/game-item.vue'
import Skeleton from '~/components/common/skeleton.vue'
import SearchForm from '~/components/common/search-form.vue'
import Lode from '~/components/desktop/pages/lobby-games/section-lode.vue'
import ProvidersFilter from '~/components/desktop/pages/common/providers-filter.vue'
import LoadMoreButton from '~/components/desktop/pages/common/load-more-button.vue'
import { useLobbyGames } from '~composables/lobby-games/use-lobby-games'

const MainMenuTab = defineAsyncComponent(async () => await import('../home/main-menu-tab.vue'))

const {
  isLoadingGame,
  gameType,
  lobbyGames,
  updateProvidersFilter,
  totalPost,
  handleScrollToGameSection,
  providerOptions,
  lobbyGameRef,
  loadMore,
  fetchGames,
  gamePayload
} = useLobbyGames()

onMounted(() => {
  handleScrollToGameSection()
})

useAsyncData('lobby-games-pc', async () => {
  const result = await fetchGames(gamePayload.value)
  lobbyGames.value = result.games
  return result
})

const limitGame = 12
</script>

<template>
  <div ref="lobbyGameRef" class="page-lobby-games">
    <MainMenuTab />

    <div class="container">
      <section id="lobbyGame" class="page-intermediate-game">
        <div class="section__content">
          <!-- Tab lode -->
          <template v-if="gameType === CATEGORY_GAME_SLUG.LODE">
            <div class="section__content--list block-lode row">
              <template v-if="isLoadingGame">
                <div v-for="index in 3" :key="index" class="col-4">
                  <Skeleton height="148px" />
                </div>
              </template>
              <template v-else>
                <div v-for="item in lobbyGames" :key="item.ID" class="col-4">
                  <GameItem hideGameName :item="item" :hasSub="false" :gameType="gameType" />
                </div>
              </template>
              <div class="col-12"><Lode /></div>
            </div>
          </template>

          <!-- Tab remaining tabs -->
          <template v-else>
            <div class="wrapper-search">
              <ProvidersFilter
                :providers="providerOptions"
                :selectedProvider="gamePayload.prov"
                @select="item => updateProvidersFilter({ value: item })"
              />
              <SearchForm v-model="gamePayload.search" />
            </div>
            <div class="section__content--list row">
              <template v-if="isLoadingGame">
                <div v-for="index in limitGame" :key="index" class="col-2">
                  <Skeleton height="250px" />
                  <br />
                </div>
              </template>
              <template v-else>
                <div v-for="item in lobbyGames" :key="item.ID" class="col-2">
                  <GameItem :item="item" />
                  <br />
                </div>
              </template>
            </div>

            <LoadMoreButton :limit="lobbyGames.length" :total="totalPost" @loadMore="loadMore" />
          </template>

          <div v-if="!lobbyGames?.length && !isLoadingGame" class="content-no-data">
            <NuxtImg
              src="/assets/images/components/lobby-games/game-nodata.png"
              width="80"
              height="80"
              fetchpriority="high"
              loading="eager"
              preload
              alt="Game nodata"
            />
            <p>
              <template v-if="gamePayload.search"> Không tìm thấy kết quả nào phù hợp! </template>
              <template v-else> Danh sách game đang cập nhật </template>
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/desktop/pages/lobby-games/index.scss';
</style>
